export default __webpack_public_path__ + "static/media/sun@3x.246a70d7.png";